<footer class="footer">
  <ul class="footerList">
    <li><a href="https://www.plusphysio.com/contact" target="_blank">Copyright</a></li>
    <li class="list">&copy; {{ today | date:'yyyy' }}</li>
    <li><a href="https://www.ifourtechnolab.com/" target="_blank">ifourtechnolab.com</a></li>
  </ul>
</footer>
